module.exports = __webpack_public_path__ + "img/user-solid.6b8f5c09.svg";